import { MaterialsApi } from "@socotec.io/materials-sdk";
import { materialsConfig } from "@/setup/openApiConfig";

export const materialInventoryApi = new MaterialsApi(materialsConfig);
